import { Component } from '@angular/core';

@Component({
  selector: 'rl-citation-placeholder',
  templateUrl: './citation-placeholder.component.html',
})
export class CitationPlaceholderComponent {}
